import React from 'react';
import PropTypes from 'prop-types';
import { CardPrimary } from './card-primary.style';

const CardPrimaryComponent = ({ label = 'heading here', value = 0, size, customColor = 'default' }) => {
    return (
        <CardPrimary className='box-shadow' size={size} customColor={customColor}>
            <h2 style={{ color: customColor }}>{value}</h2>
            <h3 style={{ color: customColor }}> {label}</h3>
        </CardPrimary>
    );
};

CardPrimaryComponent.propTypes = {
    label: PropTypes.string,
    value: PropTypes.number,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    customColor: PropTypes.string,
};

export default CardPrimaryComponent;
